//helper
import Util from "@/helper/Utility.js";
//core
import { CallbackEvent } from "@/core/Utility/CallbackEvent.js";
//service
import RegisterService from '@/module/Register/service/RegisterService.js';
//model
import { OtherBreedModel, LivestockModel } from '@/module/Register/model/RegisterLivestockModel.js';
export default function () {
    this.lbl = null;
    this.livestock = [];
    this.selectedLivestock = [];
    this.selectedLivestockCount = 0;

    this.cbLoaded = new CallbackEvent();
    this.cbError = new CallbackEvent();

    //#region setter
    this.setLbl = function (lbl) {
        this.lbl = lbl;
        return this;
    };
    //#endregion setter

    //#region livestock
    this.clearLivestock = function () {
        this.livestock = [];
        this.selectedLivestock = [];
        this.selectedLivestockCount = 0;
        this.cbLoaded.clearCallback();
        this.cbError.clearCallback();
    };
    this.getLivestock = function () {
        var isValid = true;
        //eslint-disable-next-line
        var errorMsg = '';
        console.log("selectedLivestockCount", this.selectedLivestockCount);
        if (this.selectedLivestockCount == 0) {
            //isValid = false; 
            //errorMsg = this.lbl.livestock_selected_require;
        } else {
            var selectedLivestockData = this.livestock.filter((item) => {
                return (item.isSelected);
            });
            //console.log("getLivestock", selectedLivestockData);
            var isValidAmount = false;
            var isValidName = false;
            selectedLivestockData.forEach(livestock => {
                isValidAmount = false;
                livestock.breeds.forEach(breed => {
                    if (!breed.name) {
                        isValidName = false;
                    } else {
                        isValidName = true;
                    }

                    var amount = breed.amount.toString();
                    if  (amount == null || amount == undefined) {
                        amount = 0;
                    } else {
                        amount = amount.replace(',','');
                        amount = parseInt(amount);
                    }

                    if (amount > 0)
                        isValidAmount = true;
                });

                if (!isValidName) {
                    isValid = false;
                    //console.log(this.lbl);
                    errorMsg = this.lbl.livestock_selected_name_require;
                    return;
                }

                if (!isValidAmount) {
                    isValid = false;
                    errorMsg = this.lbl.livestock_selected_amount_require;
                    return;
                }
            });
        }

        var livestocks = [];
        if (isValid) {
            if (selectedLivestockData) { 
                selectedLivestockData.forEach(livestock => {
                    var newLivestock = new LivestockModel(livestock);
                    livestocks.push(newLivestock);
                });
            }
        }

        return {
            "isValid": isValid,
            "errorMsg": errorMsg,
            "livestock": livestocks
        };
    };
    this.getProfileLivestock = function (profileLivestock) {
        RegisterService.getLivestockConfig()
            .then(result => {
                result.data.forEach(animal => {
                    animal.isSelected = false;
                    animal.breeds.forEach(breed => {
                        breed.amount = '0';
                    });
                });
                //console.log("profileLivestock", profileLivestock);
                this.livestock = result.data;
                console.log("getProfileLivestock", profileLivestock);
                profileLivestock.forEach(selectedAnimal => {
                    this.livestock.filter((animal, index) => {
                        if (selectedAnimal.value == animal.value) {
                            //fill selected information.
                            selectedAnimal.breeds.forEach((selectedBreed, selectedBreedIndex) => {
                                this.setSelectedLivestock(index, selectedAnimal);
                                if (selectedAnimal.value == 'อื่น') {
                                    var otherBreed = new OtherBreedModel();
                                    otherBreed.name = selectedBreed.name;
                                    otherBreed.nameEN = selectedBreed.name;
                                    otherBreed.value = selectedBreed.name;
                                    otherBreed.amount = Util.formatNum(selectedBreed.amount, 0);
                                    this.livestock[index].breeds.push(otherBreed);
                                } else {
                                    this.livestock[index].breeds[selectedBreedIndex].amount = Util.formatNum(selectedBreed.amount, 0);
                                }
                            });
                        }
                    });
                });

                this.cbLoaded.sendCallback();
            }).catch(err => {
                this.cbError.sendCallback(err);
            });
    };
    this.setSelectedLivestock = function (index, animal) {
        this.selectedLivestockCount++;
        this.livestock[index].isSelected = true;
        this.selectedLivestock.push(animal.name);
    };
    //#endregion livestock
}
